import BranchInfo from './BranchInfo';
export default BranchInfo;
